import React, { useState, useRef } from "react";
import Navbar from '../../components/Navbar'
import Footer from "../../components/Footer";
import WeServeIndustriesImage1 from '../../assets/we-serve-industries-startup-image-1.png'
import WeServeIndustriesImage2 from '../../assets/we-serve-industries-startup-image-2.png'
import WeServeIndustriesImage3 from '../../assets/we-serve-industries-startup-image-3.png'
import WhyChooseIndustriesMainImage from '../../assets/why-choose-industries-main-image.png'
import OrnageTick from '../../assets/point-tick.png'
import PowerfullFeaturesCardImage1 from '../../assets/powerfull-features-card-image-1.png'
import PowerfullFeaturesCardImageHover1 from '../../assets/hover-startup-image-1.png'
import PowerfullFeaturesCardImage2 from '../../assets/powerfull-features-card-image-2.png'
import PowerfullFeaturesCardImageHover2 from '../../assets/hover-startup-image-2.png'
import PowerfullFeaturesCardImage3 from '../../assets/powerfull-features-card-image-3.png'
import PowerfullFeaturesCardImageHover3 from '../../assets/hover-startup-image-3.png'
import PowerfullFeaturesCardImage4 from '../../assets/powerfull-features-card-image-4.png'
import PowerfullFeaturesCardImageHover4 from '../../assets/hover-startup-image-4.png'
import PowerfullFeaturesCardImage5 from '../../assets/powerfull-features-card-image-5.png'
import PowerfullFeaturesCardImageHover5 from '../../assets/hover-startup-image-5.png'
import PowerfullFeaturesCardImage6 from '../../assets/powerfull-features-card-image-6.png'
import PowerfullFeaturesCardImageHover6 from '../../assets/hover-startup-image-6.png'
import PowerfullFeaturesCardImage7 from '../../assets/powerfull-features-card-image-7.png'
import PowerfullFeaturesCardImageHover7 from '../../assets/hover-startup-image-7.png'
import PowerfullFeaturesCardImage8 from '../../assets/powerfull-features-card-image-8.png'
import PowerfullFeaturesCardImageHover8 from '../../assets/hover-startup-image-8.png'
import OurDataSafeSideImage from '../../assets/our-data-always-safe-side-image.png'
import OurDataGreenTick from '../../assets/our-data-green-tick-image.png'
import OurDataSageIcon1 from '../../assets/our-data-safe-icon-1.png'
import OurDataSageIcon2 from '../../assets/our-data-safe-icon-2.png'
import OurDataSageIcon3 from '../../assets/our-data-safe-icon-3.png'
import OurDataSageIcon4 from '../../assets/our-data-safe-icon-4.png'
import SmartBellIcon from '../../assets/smart-bell-icon.png'
import SmartSideImage from '../../assets/smart-startup-image.png'
import StartupImage1 from '../../assets/startup-image-1.jpg'
import StartupImage2 from '../../assets/startup-image-2.jpg'
import StartupImage3 from '../../assets/startup-image-3.jpg'
import StartupImage4 from '../../assets/startup-image-4.jpg'
// import PointTick from '../../assets/point-tick.png'
// import WhiteColorTick from '../../assets/white-color-tick.png'
// import WhatsappSmallIcon from '../../assets/whatsapp-small-icon.png'
import sendMessageImage from '../../assets/send-message-image.png'
import MessageIcon from '../../assets/message-icon-home-1.png'
import LocationIcon from '../../assets/location-icon-contactus.png'
import './Startup.css'
import { TypeAnimation } from 'react-type-animation';

const hotelData = [
    {
        name: "Freelancers",
        title: "Freelancers",
        points: [
            "Quick invoicing",
            "Expense tracking",
            "Client management",
        ],
        image: StartupImage1,
    },
    {
        name: "MSMEs",
        title: "MSMEs",
        points: [
            "Complete accounting",
            "Inventory management",
            "Staff role management",
            "Business insights"
        ],
        image: StartupImage2,
    },
    {
        name: "Startups & Corporates",
        title: "Startups & Corporates",
        points: [
            "Quick Invoicing",
            "Expense Tracking",
            "GST & Tax Compliance",
        ],
        image: StartupImage3,
    },
    {
        name: "Schools & Colleges",
        title: "Schools & Colleges",
        points: [
            "Fee Management",
            "Expense Tracking",
            "GST & Tax Compliance",
        ],
        image: StartupImage4,
    }
];

function StartUp() {
    const [selected, setSelected] = useState(hotelData[0]);
    const [activeView, setActiveView] = useState('contact');
    const [hoveredCard, setHoveredCard] = useState(null);
    const sectionRef = useRef(null);

    const scrollToSection = () => {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    const [formData, setFormData] = useState({
        name: "",
        product: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleWhatsAppSubmit = (e) => {
        e.preventDefault();

        const phoneNumber = "+917386616587";
        const { name, product } = formData;

        const whatsappMessage = `Hey, I am ${name}.\n\nI am interested in ${product} POS.\n\nLooking forward to a demo!`;

        const encodedMessage = encodeURIComponent(whatsappMessage);

        const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;

        window.open(whatsappUrl, "_blank");
        setFormData({
            name: "",
            product: "",
        });
    };
    return (
        <>
            <Navbar />
            <div className="startups-main-container">
                <div className="startup-content-container">
                    {/* <h1 className="startup-main-heading">Smart Invoicing & <span className="startup-span">Accounting</span> Made Simple</h1> */}
                    <TypeAnimation
                    sequence={[
                        // Same substring at the start will only be typed out once, initially
                        'Smart Invoicing & Accounting Made Simple',
                        1000, // wait 1s before replacing "Mice" with "Hamsters"
                        'Smart Invoicing & Accounting Made Simple For Freelancers',
                        2000,
                        'Smart Invoicing & Accounting Made Simple For MSMEs',
                        2000,
                        'Smart Invoicing & Accounting Made Simple For Startups',
                        2000,
                        'Smart Invoicing & Accounting Made Simple For Corporates',
                        2000,
                        'Smart Invoicing & Accounting Made Simple For Schools & Colleges',
                        2000
                    ]}
                    wrapper="span"
                    speed={50}
                    // style={{ fontSize: '42px', display: 'inline-block',color:"white",fontWeight:"bold",marginTop:"12px" }}
                    className="startup-main-heading"
                    repeat={Infinity}
                />
                    <p className="startup-main-description">Send invoices, track payments, and manage accounts effortlessly — all in one POS system designed for startups.</p>
                    <div className="startup-buttons-container">
                        <button className="startup-buttons" onClick={scrollToSection}>Start Free Trial</button>
                        <button className="startup-buttons startup-demo-button" onClick={scrollToSection}>Book Demo</button>
                    </div>
                </div>
            </div>

            <div className="we-serve-industries-main-container">
                <div className="we-serve-industries-content-container">
                    <h1 className="we-serve-industries-main-heading">We Serve Across Industries</h1>
                    <p className="we-server-industries-main-description">Tailored solutions for every business type</p>
                </div>
                <div className="we-serve-industries-cards-container">

                    <div className="we-serve-industries-card">
                        <img src={WeServeIndustriesImage1} alt="we-serve-image-startup" className="we-serve-image-startup" />
                        <div className="we-serve-industries-card-content">
                            <h1 className="we-serve-industries-title">Freelancers & Consultants</h1>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Quick invoicing</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Expense tracking</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Get paid faster</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Client management</p>
                            </div>
                        </div>
                    </div>

                    <div className="we-serve-industries-card">
                        <img src={WeServeIndustriesImage2} alt="we-serve-image-startup" className="we-serve-image-startup" />
                        <div className="we-serve-industries-card-content">
                            <h1 className="we-serve-industries-title">MSMEs & Small Businesses</h1>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Complete accounting</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Inventory management</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Staff role management</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Business insights</p>
                            </div>
                        </div>
                    </div>

                    <div className="we-serve-industries-card">
                        <img src={WeServeIndustriesImage3} alt="we-serve-image-startup" className="we-serve-image-startup" />
                        <div className="we-serve-industries-card-content">
                            <h1 className="we-serve-industries-title">Export & Import Startups</h1>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Multi-currency support</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Tax handling</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Global reports</p>
                            </div>
                            <div className="we-serve-industries-points">
                                <img src={OrnageTick} className="oranage-tick" alt="orange-tick" />
                                <p className="we-serve-industries-point">Compliance management</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div className="why-choose-invoice-billing-main-container">
                <div className="why-choose-invoice-content-container">
                    <h1 className="why-choose-invoice-main-heading">Why Choose Invoice Billing?</h1>
                    <p className="why-choose-invoice-main-description">Streamline your business operations with our comprehensive solution</p>
                </div>
                <img src={WhyChooseIndustriesMainImage} alt="why-choose-industries-main-image" className="why-choose-industries-main-image" />
            </div>

            <div className="powerfull-features-startups-main-container">
                <div className="powerfull-features-startups-content-container">
                    <h1 className="powerfull-features-startups-main-heading">Powerful Features</h1>
                    <p className="powerfull-features-startups-main-description">Everything you need to manage your business finances</p>
                </div>
                <div className="powerfull-features-startups-cards-container">

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card1')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage1} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card1' ? PowerfullFeaturesCardImageHover1 : PowerfullFeaturesCardImage1}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Invoice Management</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card2')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage2} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card2' ? PowerfullFeaturesCardImageHover2 : PowerfullFeaturesCardImage2}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Expense Tracking</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card3')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage3} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card3' ? PowerfullFeaturesCardImageHover3 : PowerfullFeaturesCardImage3}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">GST & Tax Handling</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card4')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage4} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card4' ? PowerfullFeaturesCardImageHover4 : PowerfullFeaturesCardImage4}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Payment Integrations</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card5')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage5} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card5' ? PowerfullFeaturesCardImageHover5 : PowerfullFeaturesCardImage5}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Multi-Currency Support</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card6')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage6} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card6' ? PowerfullFeaturesCardImageHover6 : PowerfullFeaturesCardImage6}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Custom Branding</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card7')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage7} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card7' ? PowerfullFeaturesCardImageHover7 : PowerfullFeaturesCardImage7}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Reports & Analytics</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                    <div className="powerfull-features-startup-card" onMouseEnter={() => setHoveredCard('card8')}
                        onMouseLeave={() => setHoveredCard(null)}>
                        {/* <img src={PowerfullFeaturesCardImage8} alt="powerfull-features-card-image" className="powerfull-features-card-image" /> */}
                        <img
                            src={hoveredCard === 'card8' ? PowerfullFeaturesCardImageHover8 : PowerfullFeaturesCardImage8}
                            alt="powerfull-features-card-image"
                            className="powerfull-features-card-image"
                        />
                        <h1 className="powerfull-features-card-title">Role-Based Access</h1>
                        <p className="powerfull-features-card-view-more">View Details</p>
                    </div>

                </div>
            </div>

            <div className="our-data-always-safe-main-container">
                <div className="our-data-always-safe-content-container">
                    <h1 className="our-data-always-safe-main-heading">Your Data, Always <span className="our-data-always-span">Safe</span> & <span className="our-data-always-span">Compliant</span></h1>
                    <p className="our-data-always-safe-main-description">Bank-grade security and compliance designed for startups.</p>
                </div>
                <div className="our-data-always-safe-card-container">
                    <img src={OurDataSafeSideImage} alt="our-data-always-safe-image" className="our-data-always-safe-image" />
                    <div className="our-data-always-content-container">
                        <div className="our-data-always-small-card">
                            <img src={OurDataGreenTick} alt="our-data-green-tick" className="our-data-green-tick" />
                            <p className="our-data-always-sub-heading"><span className="small-card-span">Bank-grade encryption</span> for all transactions</p>
                            <img src={OurDataSageIcon1} alt="our-data-safe-icon" className="our-data-safe-icon" />
                        </div>
                        <div className="our-data-always-small-card">
                            <img src={OurDataGreenTick} alt="our-data-green-tick" className="our-data-green-tick" />
                            <p className="our-data-always-sub-heading"><span className="small-card-span">100% GST-compliant</span> invoicing & reporting</p>
                            <img src={OurDataSageIcon2} alt="our-data-safe-icon" className="our-data-safe-icon" />
                        </div>
                        <div className="our-data-always-small-card">
                            <img src={OurDataGreenTick} alt="our-data-green-tick" className="our-data-green-tick" />
                            <p className="our-data-always-sub-heading"><span className="small-card-span">Automatic cloud backups</span> for peace of mind</p>
                            <img src={OurDataSageIcon3} alt="our-data-safe-icon" className="our-data-safe-icon" />
                        </div>
                        <div className="our-data-always-small-card">
                            <img src={OurDataGreenTick} alt="our-data-green-tick" className="our-data-green-tick" />
                            <p className="our-data-always-sub-heading"><span className="small-card-span">Secure role-based access</span> for teams</p>
                            <img src={OurDataSageIcon4} alt="our-data-safe-icon" className="our-data-safe-icon" />
                        </div>
                    </div>
                </div>
            </div>

            <div className="smart-invoice-main-container">
                <div className="smart-invoice-card-container">
                    <div className="smart-invoice-content">
                        <h1 className="smart-invoice-main-heading"><img src={SmartBellIcon} alt="smart-invoice-image" className="smart-invoice-image-icon" />Smart Invoice Reminders</h1>
                        <p className="smart-invoice-main-description">Never chase clients again — automated reminders ensure you get paid on time. Set up custom reminder schedules and let our system handle the follow-ups.</p>
                        <button className="smart-invoice-button" onClick={scrollToSection}>Learn More</button>
                    </div>
                    <div>
                        <img src={SmartSideImage} alt="smart-image" className="smart-image-invoice" />
                    </div>
                </div>
            </div>

            <div className="various-establlishment-main-container-hotel">
                <h1 className="various-establishment-heading-hotel">
                    Versatile Across Various Establishments
                </h1>

                <div className="various-establishment-buttons-container-hotel">
                    {hotelData.map((est, index) => (
                        <button
                            key={index}
                            className={`various-establishment-button-hotel ${selected.name === est.name ? "active" : ""
                                }`}
                            onClick={() => setSelected(est)}
                        >
                            {est.name}
                        </button>
                    ))}
                </div>

                <div className="various-establishment-content-container-hotel">
                    <div className="various-establishment-content-hotel">
                        <h1 className="varous-establishment-title-hotel">{selected.title}</h1>
                        <ul>
                            {selected.points.map((point, index) => (
                                <li key={index} className="various-points-hotel">
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <img
                        src={selected.image}
                        alt={`${selected.name.toLowerCase()}-image`}
                        className="super-market-image-hotel mobile-super-market-image-hotel"
                    />
                </div>
            </div>

            {/* <div className="choose-plan-top-main-container">
                <div className="choose-plan-main-container">
                    <div className="choose-plan-heading-section">
                        <h1 className="choose-plan-heading">Choose Your Plan</h1>
                        <p className="choose-plan-description">Streamline your restaurant operations with our comprehensive management solutions</p>
                    </div>
                    <div className="choose-plans-cards-container">

                        <div className="choose-plan-card">
                            <h1 className="plan-title">Standard Plan</h1>
                            <p className="plan-description">Perfect for growing restaurants</p>
                            <h1 className="plan-cost">₹6,500</h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Front Desk Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Restaurant & Bar Billing</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Franchise</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                <div className="points-plan">
                                    <img src={PointTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant Apps</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons">Get Started</button>
                                </div>
                            </div>


                        </div>

                        <div className="choose-plan-card Premium-Plan">
                            <div className="most-popular-button-container">
                                <button className="most-popular">Most Popular</button>
                            </div>
                            <h1 className="plan-title">Premium Plan</h1>
                            <p className="plan-description premium-description">Complete restaurant solution</p>
                            <h1 className="plan-cost">₹7,500</h1>
                            <div className="plan-points-container">
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Smart Upselling Engine</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Advanced Room Booking Module</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Restaurant & Bar Billing</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Reports & Analytics</p>
                                </div>

                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Inventory Management</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">24/7 Support</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Merchant Apps</p>
                                </div>
                                <div className="points-plan">
                                    <img src={WhiteColorTick} className="plan-point-tick" alt="plan-point-tick" />
                                    <p className="point-text">Custom branding option</p>
                                </div>
                            </div>
                            <div className="plan-addons-container">
                                <h1 className="plan-addon-heading">Available Add-ons</h1>
                                <div className="whatsapp-plan-container Premium-Plan-whatsapp">
                                    <div className="whatsapp-heading">
                                        <img src={WhatsappSmallIcon} alt="whatsapp-icon" className="whatsapp-small-icon" />
                                        <p className="whatsapp-title">whatsapp <span className="plans-all-text">Available with both plans</span></p>
                                    </div>
                                    <p className="plans-fotter-message">₹ 0.15 paisa/per message  (Excluding GST)</p>
                                </div>
                                <div className="plan-button-container">
                                    <button className="plan-buttons premium-button">Get Started</button>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div> */}

            <div className="contact-form-main-container-about" ref={sectionRef}>
                <div className="contact-form-content-container">
                    <div className="contactus-buttons-container">
                        <button
                            className={`contactus-form-buttons ${activeView === 'contact' ? 'active' : ''}`}
                            onClick={() => setActiveView('contact')}
                        >
                            <img src={MessageIcon} alt="message-icon" className="contact-form-icons" />
                            Contact Form
                        </button>

                        <button
                            className={`contactus-form-buttons ${activeView === 'location' ? 'active' : ''}`}
                            onClick={() => setActiveView('location')}
                        >
                            <img src={LocationIcon} alt="location-icon" className="contact-form-icons" />
                            Location
                        </button>
                    </div>



                    {activeView === 'contact' ? (
                        <>
                            <img src={sendMessageImage} alt="send-message-icon" className="send-message-icon" />
                            <h1 className="send-message-heading">Book a Demo</h1>
                            <p className="send-message-description">
                                Fill out the form below and connect us instantly.
                            </p>

                            <form className="send-message-form-main" onSubmit={handleWhatsAppSubmit}>
                                <div className="send-message-form">
                                    <div className="input-container">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="John Doe"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                    {/* <div className="input-container">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="john@example.com"
                                            className="input-field"
                                            onChange={handleChange}
                                            required
                                        />
                                    </div> */}
                                </div>

                                <div className="input-container">
                                    <label>Product</label>
                                    <select
                                        name="product"
                                        className="input-field"
                                        onChange={handleChange}
                                        required
                                    >
                                        {/* <option value="">Select a product</option>
                                        <option value="Fleet Eats">Fleet Eats</option>
                                        <option value="Fleet Mart">Fleet Mart</option>
                                        <option value="Fleet Stay">Fleet Stay</option> */}
                                        <option value="Fleet Office">Fleet Office</option>
                                    </select>
                                </div>

                                {/* <div className="input-container">
                                    <label>Message</label>
                                    <textarea
                                        name="message"
                                        placeholder="Type your message here..."
                                        className="input-field"
                                        rows="6"
                                        onChange={handleChange}
                                        required
                                    ></textarea>
                                </div> */}

                                <button type="submit" className="send-message-button">
                                    Connect Us
                                </button>
                            </form>
                        </>
                    ) : (
                        // Location View
                        <div className="map-image-background">
                            <div className="reach-out-cards-container">
                               <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.5253765500493!2d78.37664357522262!3d17.434550583460727!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93e37831f177%3A0x32d4499d34baaa78!2sT-Hub%20Phase%202!5e0!3m2!1sen!2sin!4v1781782551831!5m2!1sen!2sin" 
                                width="600" 
                                height="450" 
                                style={{ border: 0 }} 
                                allowfullscreen 
                                loading="lazy" 
                                referrerpolicy="no-referrer-when-downgrade"
                                title="Thub Phase 2 Map"
                                ></iframe>
                            </div>
                        </div>

                    )}

                </div>
            </div>
            <Footer />
        </>
    )
}

export default StartUp